var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('custom-container', {
    class: "image-gallery ".concat(_vm.isMobile ? 'image-gallery-mobile' : 'image-gallery-desktop')
  }, [_c('custom-container', {
    attrs: {
      "id": "library-3d-scene"
    }
  }, [_c('div', {
    staticClass: "image-gallery-rotate"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.showRotateMsg ? _c('custom-tooltip', {
    attrs: {
      "customsClasses": "image-gallery-rotate-tooltip"
    }
  }, [_c('p', {
    staticClass: "image-gallery-rotate-text"
  }, [_vm._v(_vm._s(_vm.translations.rotateImage))])]) : _vm._e()], 1), _c('custom-container', {
    on: {
      "click": function click() {
        _vm.showRotateMsgTooltip();
      }
    }
  }, [_c('custom-image', {
    attrs: {
      "src": "".concat(_vm.customsAssets, "/svg/customizer/icon-image-rotate-3d.svg"),
      "customClass": "image-gallery-rotate-icon"
    }
  })], 1)], 1)]), _c('custom-container', {
    attrs: {
      "customClass": "image-gallery-container"
    }
  }, _vm._l(_vm.gallery, function (item, indexGallery) {
    var _vm$translations, _vm$translations$cate, _vm$translations2, _vm$translations2$cat, _vm$translations2$cat2, _item$key;
    return _c('custom-container', {
      key: indexGallery,
      attrs: {
        "id": "gallery-".concat(indexGallery),
        "customClass": "image-gallery-item"
      }
    }, [_c('custom-container', {
      staticClass: "image-gallery-text-container"
    }, [_c('custom-text', {
      staticClass: "image-gallery-text-container__text-box",
      attrs: {
        "elementType": "h2",
        "text": ((_vm$translations = _vm.translations) === null || _vm$translations === void 0 ? void 0 : (_vm$translations$cate = _vm$translations.categories) === null || _vm$translations$cate === void 0 ? void 0 : _vm$translations$cate[item.key]) || item.key
      }
    }), _c('button', {
      staticClass: "image-gallery-text-container__see-all",
      attrs: {
        "aria-label": "".concat(((_vm$translations2 = _vm.translations) === null || _vm$translations2 === void 0 ? void 0 : (_vm$translations2$cat = _vm$translations2.categories) === null || _vm$translations2$cat === void 0 ? void 0 : (_vm$translations2$cat2 = _vm$translations2$cat[item.key]) === null || _vm$translations2$cat2 === void 0 ? void 0 : _vm$translations2$cat2.toUpperCase()) || ((_item$key = item.key) === null || _item$key === void 0 ? void 0 : _item$key.toUpperCase()), " ").concat(item.isExpanded ? _vm.translations.addYourImageGallerySeeLess : _vm.translations.addYourImageGallerySeeAll)
      },
      on: {
        "click": function click($event) {
          return _vm.toggleExpand(indexGallery);
        }
      }
    }, [_c('custom-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !item.isExpanded,
        expression: "!item.isExpanded"
      }],
      attrs: {
        "elementType": "span",
        "text": _vm.translations.addYourImageGallerySeeAll
      }
    }), _c('custom-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.isExpanded,
        expression: "item.isExpanded"
      }],
      attrs: {
        "elementType": "span",
        "text": _vm.translations.addYourImageGallerySeeLess
      }
    }), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !item.isExpanded,
        expression: "!item.isExpanded"
      }],
      staticClass: "text-box-icon icon-arrow-right-indicator"
    }), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.isExpanded,
        expression: "item.isExpanded"
      }],
      staticClass: "text-box-icon icon-arrow-down-indicator"
    })], 1)], 1), _c('custom-container', {
      class: "image-gallery-carrousel ".concat(item.isExpanded ? 'image-gallery-carrousel__expanded' : '')
    }, [_c('custom-container', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.isMobile && !item.isExpanded,
        expression: "!isMobile && !item.isExpanded"
      }],
      staticClass: "icon-arrow-left-indicator icon-arrow-left-indicator-open show-left-arrow icon-arrow",
      on: {
        "click": function click() {
          _vm.scrollGalleryLeft(indexGallery);
        }
      }
    }), _c('custom-container', {
      class: "scroll-column ".concat(item.isExpanded ? 'expanded' : ''),
      attrs: {
        "id": "image-gallery-carrousel-".concat(indexGallery)
      }
    }, _vm._l(item[item.key], function (img) {
      var _vm$translations3, _vm$translations3$ima, _vm$translations4, _vm$translations4$ima;
      return _c('custom-container', {
        key: img.ugc.original_image.image_id,
        class: {
          'disabled': _vm.isLoadingImage
        },
        attrs: {
          "elementType": "button",
          "disabled": _vm.isLoadingImage,
          "id": "gallery-image-".concat(indexGallery, "-").concat(img.ugc.original_image.image_id),
          "customClass": "image-container frame-carrousel-image-container",
          "aria-label": (_vm$translations3 = _vm.translations) === null || _vm$translations3 === void 0 ? void 0 : (_vm$translations3$ima = _vm$translations3.images) === null || _vm$translations3$ima === void 0 ? void 0 : _vm$translations3$ima[img.image_name]
        },
        on: {
          "click": function click() {
            _vm.onSelectImage(img, item.key);
          }
        }
      }, [_c('custom-container', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: img.ugc.original_image.image_id === _vm.selectedImageId,
          expression: "img.ugc.original_image.image_id === selectedImageId"
        }],
        attrs: {
          "elementType": "div",
          "customClass": "icon-check"
        }
      }), _c('custom-image', {
        staticClass: "disabledImage image-item",
        attrs: {
          "src": img.image_thumb,
          "draggable": "false",
          "alt": (_vm$translations4 = _vm.translations) === null || _vm$translations4 === void 0 ? void 0 : (_vm$translations4$ima = _vm$translations4.images) === null || _vm$translations4$ima === void 0 ? void 0 : _vm$translations4$ima[img.image_name]
        },
        on: {
          "!contextmenu": function contextmenu($event) {
            $event.preventDefault();
          }
        }
      })], 1);
    }), 1), _c('custom-container', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.isMobile && !item.isExpanded,
        expression: "!isMobile && !item.isExpanded"
      }],
      staticClass: "icon-arrow-right-indicator icon-arrow-right-indicator-open show-right-arrow icon-arrow",
      on: {
        "click": function click() {
          _vm.scrollGalleryRight(indexGallery);
        }
      }
    })], 1)], 1);
  }), 1), _c('CustomButton', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.image,
      expression: "image"
    }],
    attrs: {
      "customClass": "button primary selected-image-next",
      "type": "button",
      "disable": !_vm.image,
      "text": _vm.translations.addYourImageGalleryContinueToCustomize
    },
    on: {
      "click": function click($event) {
        return _vm.ctaPrimaryAction();
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }